import { Component, OnInit } from '@angular/core';
import { IAnnotation, ICommunication } from '@ahryman40k/ts-fhir-types/lib/R4';
import { AlertDecourseDetailsComponent } from '../../../shared/abstracts/alert-decourse-details/alert-decourse-details.component';
import { TranslatePipe } from '../../../shared/translate/pipes/translate.pipe';

@Component({
  selector: 'inc-alert-details',
  templateUrl: './alert-details.component.html',
  styleUrls: ['./alert-details.component.scss'],
})
export class AlertDetailsComponent extends AlertDecourseDetailsComponent<ICommunication> implements OnInit {

  constructor(private translatePipe: TranslatePipe) { super(); }

  ngOnInit() { super.ngOnInit(); }

  onCallSaveComment(comment: IAnnotation): void {
    this.inData.note.push(comment);
    this.callCommentSaveAndUpdate.emit(this.inData);
  }

  onCallUpdateComment(comment: IAnnotation): void {
    this.inData.note[this.commentUpdateId] = comment;
    this.callCommentSaveAndUpdate.emit(this.inData);
  }

  onCallCancelComment(): void { this.callCancelComment.emit(); }

  onCallCommentMore(comment: IAnnotation): void {
    this.callCommentMore.emit({
      component: this.inData,
      index: this.inData.note.indexOf(comment)
    });
  }

  onCallSaveAndApprove(comment: IAnnotation): void {
    if (!this.inData.note) {
      this.inData.note = [];
    }

    this.inData.priority = 'routine';
    this.inData.status = 'completed';

    this.inData.note.push(comment);
    this.callCommentSaveAndUpdate.emit(this.inData);
  }

  getAlertType(): string {
    if (this.inData.reasonReference.length &&
      !(this.inData.reasonReference[0].reference === '' || this.inData.reasonReference[0].reference === 'undefined')) {
      return this.inData.reasonReference[0].display;
    }
    return '';
  }

  getCategoryText(): string {
    if (this.inData && this.inData.category && this.inData.category.length > 0 && this.inData.category[0].text) {
      if (this.inData.category[0].text.includes('_MEASUREMENT')) {
        const splitted = this.inData.category[0].text.split('_');
        if (splitted.length === 3 && splitted[splitted.length - 1] === 'MEASUREMENT') {
          return (this.translatePipe.transform('MEASUREMENT_FIRST') + ' ' + splitted[0] + ' ' +
            this.translatePipe.transform(splitted[1] + '_MEASUREMENT') + ' ' + this.translatePipe.transform('MEASUREMENT_SECOND'))
            .trim();
        }
      } else {
        return this.translatePipe.transform(this.inData.category[0].text);
      }
    }
    return '';
  }
}
